import { Avatar, Box, Grid, Paper, Typography } from "@mui/material";
import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import Table from "../../components/Table";
import Loading from "../loading/Loading";
import { singleUser } from "../../../states/actions/userAction";
import { viewNews, postedByNews } from "../../../states/actions/newsAction";
import { useDispatch, useSelector } from "react-redux";
import Layout from "../layout/Layout";
import BaseUrl from "../../../service/API/base_url";
import { useTranslation } from "react-i18next";

const SingleUser = () => {
  // dispatch
  const dispatch = useDispatch();
  // hooks
  const users = useSelector((state) => state.users);
  const blogs = useSelector((state) => state.blogs);
  const { id } = useParams();
  // use effect
  useEffect(() => {
    dispatch(singleUser(id));
  }, []);

  // use effect
  useEffect(() => {
    dispatch(viewNews());
  }, []);

  const { t: translate } = useTranslation(["loginAndregister"]);
  return (
    <Layout title={"User"}>
      <Box sx={{ pt: "80px", pb: "20px" }}>
        <Typography variant="h5">{translate("Customer Details")} </Typography>

        <Grid container spacing={3}>
          <Grid item xs={12} md={6} lg={4} sx={{ mt: 4 }}>
            <Paper
              sx={{
                boxShadow: "none !important",
                borderRadius: "12px",
                borderStyle: "solid",
                borderWidth: "1px",
                borderColor: "divider",
                p: "20px",
              }}
            >
              <Box sx={{ textAlign: "center" }}>
                <Avatar
                  src={`${BaseUrl}${users?.users?.photo1}`}
                  sx={{ width: "80px", height: "80px", mx: "auto" }}
                />
                <Typography variant="h6" sx={{ my: 1 }}>
                  {users?.users?.firstName}
                </Typography>

                <Box sx={{ mt: 2 }}>
                  <Typography
                    variant="subtitle2"
                    sx={{ fontSize: "15px", mb: 2 }}
                  >
                    {translate("LastName")} :{" "}
                    <span style={{ opacity: 0.7 }}>
                      {users?.users?.lastName}
                    </span>
                  </Typography>
                  <Typography
                    variant="subtitle2"
                    sx={{ fontSize: "15px", mb: 2 }}
                  >
                    {translate("Email")}{" "}
                    <span style={{ opacity: 0.7 }}>{users?.users?.phone}</span>
                  </Typography>
                  <Typography
                    variant="subtitle2"
                    sx={{ fontSize: "15px", mb: 2 }}
                  >
                    {translate("Address")} :{" "}
                    <span style={{ opacity: 0.7 }}>
                      {translate("bahirdar")}
                    </span>
                  </Typography>
                </Box>
              </Box>
            </Paper>
          </Grid>
          <Grid item xs={12} md={6} lg={8}>
            <Typography variant="h6">{translate("Post info list")}</Typography>

            {blogs?.News ? (
              <Table
                data={blogs?.News}
                fields={blogsColumns}
                numberOfRows={blogs?.News?.length}
                enableTopToolBar={true}
                enableBottomToolBar={true}
                enablePagination={true}
                enableRowSelection={true}
                enableColumnFilters={true}
                // enableEditing={true}
                enableColumnDragging={true}
                showPreview={true}
              />
            ) : (
              <Loading />
            )}
          </Grid>
        </Grid>
      </Box>
    </Layout>
  );
};

export default SingleUser;
const blogsColumns = [
  {
    accessorKey: "author", //access nested data with dot notation
    header: "Author Name",
  },

  {
    accessorKey: "title", //access nested data with dot notation
    header: "Title",
  },

  // {
  //   accessorKey: "description", //access nested data with dot notation
  //   header: "Description",
  // },
  {
    accessorKey: "photo", //access nested data with dot notation
    header: "Images",
    size: 100,
    Cell: ({ cell }) => (
      <div>
        <Avatar
          src={`${BaseUrl}${cell.getValue()}`.replace(/([^:]\/)\/+/g, "$1")}
          // sx={{ width: 100, height: 100 }}
          variant="rounded"
        />
      </div>
    ),
  },
];
